import styled from 'styled-components';

export const Img = styled('img')`
  width: 50px;
  height: 50px;
  object-fit: contain;
  transform: rotate(35deg);
  margin-right: -10px;
`;
